import LayoutsDataTable from "../../../components/dataTable/tables/LayoutsDataTable";

function LayoutsPageView() {
  return <LayoutsDataTable />;
}

export default LayoutsPageView;
